import React, { ReactNode } from 'react'

interface IconProps {
  children: ReactNode
  className?: string
}

export const Icon: React.FC<IconProps> = ({ children, className = '' }) => {
  return <span className={`icon material-icons ${className}`}>{children}</span>
}
